import { Link } from 'react-router-dom'

interface PublicFooterProps {
  faqLabel?: string
  privacyLabel?: string
  termsLabel?: string
}

export function PublicFooter({
  faqLabel = 'FAQ',
  privacyLabel = 'Privacy Policy',
  termsLabel = 'Terms of Service',
}: PublicFooterProps) {
  return (
    <footer className="border-t border-slate-900/[0.05] py-8 text-center text-xs text-muted-foreground">
      <nav aria-label="Site" className="mb-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
        <Link to="/faq" className="transition-colors hover:text-foreground">
          {faqLabel}
        </Link>
        <Link to="/privacy" className="transition-colors hover:text-foreground">
          {privacyLabel}
        </Link>
        <Link to="/terms" className="transition-colors hover:text-foreground">
          {termsLabel}
        </Link>
      </nav>
      <p>© {new Date().getFullYear()} Lexio</p>
    </footer>
  )
}
